/** 与 .env 中 PRIMARY_ADMIN_USERNAME（默认 admin）及 VITE_PRIMARY_ADMIN_USERNAME 对齐 */
export function getPrimaryAdminLoginForUi() {
  const raw = String(
    (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_PRIMARY_ADMIN_USERNAME) || '',
  ).trim();
  return raw || 'admin';
}

export const BATCH_CREATE_ROLE_OPTIONS = [{ value: 'user', label: '普通用户' }];

export const CREATE_USER_ROLE_OPTIONS = [{ value: 'user', label: '普通用户' }];

export function normalizePlatformRoleForEdit(role) {
  const r = String(role || '').trim();
  if (r === 'groupLeader' || r === 'ceo') return 'user';
  if (r === 'admin') return 'admin';
  return 'user';
}

/** 编辑用户时可选平台角色：仅主管理员账号可出现「管理员」 */
export function getEditUserRoleOptions(editingUsername) {
  const primary = getPrimaryAdminLoginForUi().toLowerCase();
  const u = String(editingUsername || '').trim().toLowerCase();
  if (u === primary) {
    return [
      { value: 'admin', label: '管理员' },
      { value: 'user', label: '普通用户' },
    ];
  }
  return [{ value: 'user', label: '普通用户' }];
}

/** @deprecated 请使用 getEditUserRoleOptions(username) */
export const EDIT_USER_ROLE_OPTIONS = [
  { value: 'user', label: '普通用户' },
  { value: 'admin', label: '管理员' },
];

export const PERMISSION_BASIS_OPTIONS = [{ value: 'user', label: '按用户配置' }];

export function isAuditGroupHiddenByRole(role) {
  return role === 'admin' || role === 'ceo';
}

export function isAuditGroupSelectDisabledByRole(role) {
  return role === 'admin' || role === 'ceo';
}

export function buildCreateUserRoleChangeState() {
  return { role: 'user', auditGroup: '' };
}

export function buildEditUserRoleChangeState(nextRole, currentAuditGroup = '') {
  return {
    role: nextRole,
    auditGroup: isAuditGroupHiddenByRole(nextRole) ? '' : currentAuditGroup,
  };
}
